// extracted by mini-css-extract-plugin
module.exports = {"panel":"AccordionItemPanel_panel__WDY57","content":"AccordionItemPanel_content__aGtT_"};